/**
 * Created by dinesh on 13/6/17.
 */
import {RouterModule, Routes} from '@angular/router';
import {DataOutputComponent} from './shared/data-output.component';
import { ReportViewerComponent } from './shared/report-viewer/report-viewer.component';
import {HelpManualComponent} from './shared/help/help-manual/help-manual.component';
import { DecisionManualComponent } from './shared/help/decision-manual/decision-manual.component';
import {PopupLinkComponent} from './shared/popup-link/popup-link.component';
import {GettingStartedComponent} from './shared/help/getting-started/getting-started.component';
import {SupportComponent} from './shared/help/support/support.component';


const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'student', loadChildren: () => import('./student/student.module').then(m => m.StudentModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'instructor-admin', loadChildren: () => import('./instructor-admin/instructor-admin.module').then(m => m.InstructorAdminModule) },
  { path: 'instructor', loadChildren: () => import('./instructor/instructor.module').then(m => m.InstructorModule) },
  { path: 'admin/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'instructor/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'instructor-admin/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'student/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'report/viewer', component: ReportViewerComponent },
  { path: 'help_manual', component: HelpManualComponent},
  { path: 'decision_manual', component: DecisionManualComponent},
  { path: 'links', component: PopupLinkComponent},
  { path: 'getting_started', component: GettingStartedComponent},
  { path: 'support', component: SupportComponent}




  // {path: 'home', component: HomeComponent, canActivate: [RoleGuard]},
  // {
  //   path: 'admin', component: AdminComponent, canActivate: [RoleGuard],
  //   children: [
  //     {
  //       path: 'stats',
  //       component: StatsComponent
  //     }
  //   ]
  // },
  // {path: 'instructor', component: InstructorComponent, canActivate: [Role./Guard]},
  // {path: 'student', component: StudentComponent, canActivate: [RoleGuard]},
  // {path: 'instructor-admin', component: InstructorAdminComponent, canActivate: [RoleGuard]}
];
export const routing = RouterModule.forRoot(routes);
